module.exports = __webpack_public_path__ + "static/media/04.-6-7.6195a3c1.jpg";